import React, { useEffect, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const PortfolioLightbox = ({ items, currentIndex, onClose, onPrev, onNext }) => {
  const item = items[currentIndex];

  const handleKey = useCallback(
    (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    },
    [onClose, onPrev, onNext]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [handleKey]);

  if (!item) return null;

  return (
    <div
      className="fixed inset-0 z-[200] bg-black/95 flex items-center justify-center"
      onClick={onClose}
      data-testid="lightbox-overlay"
    >
      {/* Close */}
      <button
        onClick={onClose}
        className="absolute top-5 right-5 md:top-8 md:right-8 z-10 w-12 h-12 border border-white/30 bg-black text-white flex items-center justify-center hover:border-[#c0392b] hover:text-[#c0392b] transition-colors cursor-pointer"
        aria-label="Fechar"
        data-testid="lightbox-close"
      >
        <X size={22} />
      </button>

      {/* Counter */}
      <div className="absolute top-6 left-6 md:top-8 md:left-10 font-heading text-white/50 tracking-[0.3em] text-xs uppercase">
        {currentIndex + 1} / {items.length}
      </div>

      {/* Prev */}
      <button
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
        disabled={currentIndex === 0}
        className="absolute left-3 md:left-6 z-10 w-12 h-12 border border-white/30 bg-black text-white flex items-center justify-center hover:border-[#c0392b] hover:text-[#c0392b] transition-colors disabled:opacity-20 disabled:cursor-not-allowed cursor-pointer"
        aria-label="Foto anterior"
        data-testid="lightbox-prev"
      >
        <ChevronLeft size={24} />
      </button>

      {/* Image */}
      <div
        className="relative max-w-[90vw] max-h-[85vh] flex flex-col items-center gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={item.url}
          alt={item.description || item.category}
          className="max-w-full max-h-[78vh] object-contain"
          style={{ filter: "grayscale(100%) contrast(1.05)" }}
          data-testid="lightbox-image"
        />
        {item.category && (
          <div className="font-heading text-[#c0392b] tracking-[0.35em] text-xs uppercase">
            {item.category}
          </div>
        )}
      </div>

      {/* Next */}
      <button
        onClick={(e) => { e.stopPropagation(); onNext(); }}
        disabled={currentIndex === items.length - 1}
        className="absolute right-3 md:right-6 z-10 w-12 h-12 border border-white/30 bg-black text-white flex items-center justify-center hover:border-[#c0392b] hover:text-[#c0392b] transition-colors disabled:opacity-20 disabled:cursor-not-allowed cursor-pointer"
        aria-label="Próxima foto"
        data-testid="lightbox-next"
      >
        <ChevronRight size={24} />
      </button>
    </div>
  );
};

export default PortfolioLightbox;
